import { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { AppContext } from '../../../appContext/AppContext';
import FilterSidebar from '../../../component/filter-sidebar/FilterSidebar';
import LazyLoadTable from '../../../component/lazy-load-table/LazyLoadTable';
import { CODE, RESPONSE_MESSAGE } from '../../../utils/Constant';
import { formatDateToYYYYMMDD } from '../../../utils/FormatUtils';
import { PATIENT_COLUMNS } from '../../columns';
import { FILTER_OPTIONS, VIEW_TYPE_CONFIG } from '../../constants';
import { usePhanHeBaoHiemYTeContext } from '../../contexts';
import { getPatientInfo, getPatientList, getPatientListSummary } from '../../services';

const PatientList = () => {
	const { setSelectedPatient, selectedPatient, setPatientInfo, statusChange, setViewType } =
		usePhanHeBaoHiemYTeContext();
	const { setIsLoading } = useContext(AppContext);

	const [searchObject, setSearchObject] = useState<any>(null);
	const [listFilter, setListFilter] = useState<any>(null);
	const [statusSummary, setStatusSummary] = useState([]);

	const filterRef = useRef<any>(null);

	useEffect(() => {
		if (!listFilter) {
			return;
		}

		setSearchObject({
			...listFilter,
			order: null,
		});
	}, [listFilter]);

	useEffect(() => {
		if (searchObject) {
			getStatusSummary(searchObject);
		}
	}, [searchObject, statusChange]);

	useEffect(() => {
		if (selectedPatient?.id) {
			getPatientDetail(selectedPatient?.id);
		}
	}, [statusChange]);

	const handleSelectedBenhNhan = async (patientRowData: any) => {
		try {
			setSelectedPatient(patientRowData);
			getPatientDetail(patientRowData.id);
		} catch (error) {
			console.error(error);
			toast.warning(RESPONSE_MESSAGE.ERROR);
		} finally {
			setIsLoading(false);
		}
	};

	const getPatientDetail = async (patientId: string) => {
		try {
			setIsLoading(true);
			const { data, code } = await getPatientInfo(patientId);

			if (CODE.SUCCESS === code) {
				setPatientInfo(data);
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		} finally {
			setIsLoading(false);
		}
	};

	const doSearch = (props: any) => {
		const searchObject = {
			keyword: props?.keyword || null,
			barcode: props?.additionalFieldSearch || null,
			sortBy: props.formal?.value || listFilter?.sortBy || null,
			descending: props.order?.value === 'DERCEASE' || !props.order,
			order: props.order,
			fromDate: formatDateToYYYYMMDD(props.period?.fromDate) || listFilter?.fromDate,
			toDate: formatDateToYYYYMMDD(props.period?.toDate) || listFilter?.toDate,
			filterBy: props?.filterBy || listFilter?.filterBy || null,
			filterValue: props?.filterValue || listFilter?.filterValue || null,
		};
		filterRef.current = searchObject;
		setListFilter({
			...searchObject,
		});
	};

	const getStatusSummary = async (params: any) => {
		try {
			const { filterBy, filterValue, ...otherParams } = params;
			const { data } = await getPatientListSummary(otherParams);
			setStatusSummary(data || []);
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<div>
			<FilterSidebar
				title="Danh sách bệnh nhân"
				formalList={FILTER_OPTIONS}
				onSearch={doSearch}
				listMenuItem={[
					{
						listItem: [
							{
								name: 'Danh sách Check-in',
								code: VIEW_TYPE_CONFIG.PATIENT_CHECK_IN,
							},
							{
								name: 'Danh sách Duyệt BHYT',
								code: VIEW_TYPE_CONFIG.PATIENT_APPROVE,
							},
						],
					},
				]}
				handleSelectOption={(item: any) => {
					setViewType(item.code);
				}}
			/>

			<div className="spaces h-calc-vh-170 d-flex flex-column justify-content-between pt-10">
				<div className="spaces">
					<LazyLoadTable
						columns={PATIENT_COLUMNS}
						axiosReq={getPatientList}
						searchData={searchObject}
						className="spaces h-calc-vh-261"
						onRowClick={(row: any) => handleSelectedBenhNhan(row)}
						dependencies={[statusChange]}
						rowSeclected={selectedPatient}
						rowKey="id"
					/>
				</div>
				<div className="count-status-xet-nghiem spaces w-100 gap-10 px-5 justify-content-center mx-auto">
					{statusSummary.map((item: any, index: number) => (
						<div
							key={index}
							className="d-flex status text-white rounded spaces px-8 py-4 w-100 justify-content-center cursor-pointer"
							style={{ backgroundColor: item.color }}
							onClick={() => {
								doSearch({
									...listFilter,
									filterBy: 'currStatusCode',
									filterValue: item?.statusCode,
								});
							}}
						>
							<span className="body-normal-1 spaces">{`${item.statusName}: ${item.summary}`}</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default PatientList;
